/**
 * Stable CSS class names for E2E — Order detail order information card & related UI.
 */

export const OIC = {
    root: 'order-detail-order-information-card',
    drawerStatusHistoryPaper: 'order-detail-order-information-card__drawer-status-history-paper',
    drawerGiftCardPaper: 'order-detail-order-information-card__drawer-gift-card-paper',
    dialogCancelPaper: 'order-detail-order-information-card__dialog-cancel-order-paper',
    dialogCancelTitleRow: 'order-detail-order-information-card__dialog-cancel-title-row',
    dialogCancelCloseButton: 'order-detail-order-information-card-input--button-dialog-cancel-close',
    headerCard: 'order-detail-order-information-card__header-card',
    headerTitleRow: 'order-detail-order-information-card__header-title-row',
    headerIcon: 'order-detail-order-information-card__header-icon',
    headerTitle: 'order-detail-order-information-card__header-title',
    headerActions: 'order-detail-order-information-card__header-actions',
    statusChipWrap: 'order-detail-order-information-card__status-chip-wrap',
    chipOrderStatus: 'order-detail-order-information-card__chip-order-status',
    deliveryIconWrap: 'order-detail-order-information-card__delivery-icon-wrap',
    deliveryIcon: 'order-detail-order-information-card__delivery-method-icon',
    inputButtonGiftCard: 'order-detail-order-information-card-input--button-gift-card-info',
    inputButtonOrderHistory: 'order-detail-order-information-card-input--button-order-status-history',
    moreMenuWrap: 'order-detail-order-information-card__more-menu-wrap',
    inputButtonMore: 'order-detail-order-information-card-input--button-more-actions',
    actionsMenu: 'order-detail-order-information-card__actions-menu',
    menuItemCreateReturn: 'order-detail-order-information-card__menu-item-create-return',
    menuItemReturnList: 'order-detail-order-information-card__menu-item-return-list',
    menuItemRefundList: 'order-detail-order-information-card__menu-item-refund-list',
    menuItemCancelOrder: 'order-detail-order-information-card__menu-item-cancel-order',
    divider: 'order-detail-order-information-card__divider',
    bodyCard: 'order-detail-order-information-card__body-card',
    bodyContent: 'order-detail-order-information-card__body-content',
    orderNumberRow: 'order-detail-order-information-card__order-number-row',
    orderDateRow: 'order-detail-order-information-card__order-date-row',
    orderIdRow: 'order-detail-order-information-card__order-id-row',
    copyOrderNumberWrap: 'order-detail-order-information-card__copy-order-number-wrap',
    copyOrderIdWrap: 'order-detail-order-information-card__copy-order-id-wrap',
} as const;

export const OIC_CO = {
    loading: 'order-detail-cancel-order__loading',
    error: 'order-detail-cancel-order__error',
    rootCard: 'order-detail-cancel-order__root-card',
    content: 'order-detail-cancel-order__content',
    form: 'order-detail-cancel-order__form',
    formColumn: 'order-detail-cancel-order__form-column',
    reasonControl: 'order-detail-cancel-order__reason-form-control',
    reasonLabel: 'order-detail-cancel-order__reason-label',
    inputSelectReason: 'order-detail-cancel-order-input--select-cancel-reason',
    inputTextOtherReason: 'order-detail-cancel-order-input--text-other-reason',
    inputButtonSubmit: 'order-detail-cancel-order-input--button-submit',
} as const;

export const OIC_DCI = {
    modal: 'order-detail-digital-card-info__alt-contact-modal',
    modalBox: 'order-detail-digital-card-info__modal-box',
    modalForm: 'order-detail-digital-card-info__modal-form',
    modalTitle: 'order-detail-digital-card-info__modal-title',
    inputPhoneOther: 'order-detail-digital-card-info-input--phone-other',
    inputEmailOther: 'order-detail-digital-card-info-input--text-email-other',
    inputButtonModalSend: 'order-detail-digital-card-info-input--button-modal-send',
    drawerCard: 'order-detail-digital-card-info__drawer-card',
    headerRow: 'order-detail-digital-card-info__header-row',
    closeIcon: 'order-detail-digital-card-info-input--icon-close-drawer',
    title: 'order-detail-digital-card-info__title',
    tableContainer: 'order-detail-digital-card-info__table-container',
    table: 'order-detail-digital-card-info__table',
    cardImage: 'order-detail-digital-card-info__card-image',
    actionsColumn: 'order-detail-digital-card-info__actions-column',
    inputButtonSms: 'order-detail-digital-card-info-input--button-send-sms',
    inputButtonMail: 'order-detail-digital-card-info-input--button-send-mail',
    inputButtonSmsOther: 'order-detail-digital-card-info-input--button-sms-other-phone',
    inputButtonMailOther: 'order-detail-digital-card-info-input--button-mail-other-email',
    warningWrap: 'order-detail-digital-card-info__warning-wrap',
    warningAlert: 'order-detail-digital-card-info__warning-alert',
} as const;

export const OIC_DI = {
    root: 'order-detail-discount-info__root',
    title: 'order-detail-discount-info__title',
    dialogContent: 'order-detail-discount-info__dialog-content',
    contentInner: 'order-detail-discount-info__content-inner',
    table: 'order-detail-discount-info__table',
    headerRow: 'order-detail-discount-info__header-row',
    discountRow: 'order-detail-discount-info__discount-row',
    footerDivider: 'order-detail-discount-info__footer-divider',
    footerTotal: 'order-detail-discount-info__footer-total',
} as const;

export const oicCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
